export default "<!-- Root Outlet - Pass Through -->\r\n<router-outlet></router-outlet>\r\n"